<template>
  <div class="text-truncate" v-html="eventLabel" :title="eventLabel.replace(/(<([^>]+)>)/gi, '')"></div>
</template>

<script>
export default {
  name: "EventTypeRenderer",
  data: () => ({
      knownEvents: [
          'sending',
          'cancel',
          'expired',
          'association',
          'dissociation',
          'diagnostic',
          'diagnostic_auto',
          'permissions'
      ]
  }),
  props: ["object", "columnKey"],
  computed: {
      eventLabel: function () {
          if(this.knownEvents.includes(this.object[this.columnKey])){
              return window.V.$i18n.t(`reports.logsTable.events.${this.object[this.columnKey]}.text`);
          } else {
              return window.V.$i18n.t(`reports.logsTable.events.default.text`);
          }
      }
  }
};
</script>
  